import Vue from 'vue';
import Vuex from 'vuex';
import {getUserinfo, getCertifinfo, getUserCheck} from '@/api';
import router from '../router';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    userInfo: '',
    certifInfo: null,
    powerCount: 0,
    tortCount: 0,
    resetvisible: false,
    imgprivewData: {
      visible: false,
      src: ''
    },
    imgprivewSrc: ''
  },
  mutations: {
    setimgprivewData(state, data) {
      state.imgprivewData = data;
    },
    setResetVisible(state, data) {
      state.resetvisible = data;
    },
    setUserInfo(state, data) {
      localStorage.setItem('userInfo', JSON.stringify(data));
      state.userInfo = data;
    },
    setcertifInfo(state, data) {
      state.certifInfo = data;
    },
    setpowerCount(state, data) {
      state.powerCount = data;
    },
    settortCount(state, data) {
      state.tortCount = data;
    },
    loginOut(state) {
      state.userInfo = '';
    }
  },
  actions: {
    getUserinfoByStore({state, commit}, data) {
      return new Promise((resolve, reject) => {
        if (data) {
          commit('setUserInfo', data);
        }
        getUserCheck().then(_ => {
          getUserinfo().then(res => {
            commit('setUserInfo', Object.assign({}, state.userInfo, res.data.sysUser));
            if (state.userInfo.realFlag === '1') {
              getCertifinfo(state.userInfo.userId).then(res => {
                if (res.code === 0) {
                  let resdata = res.data;
                  if (resdata.licnse) {
                    resdata.licnse.autoOption = JSON.parse(resdata.licnse.autoOption);
                    resdata.licnse.manualOption = JSON.parse(resdata.licnse.manualOption);
                  } else {
                    resdata.noLicnse['autoOption'] = JSON.parse(resdata.noLicnse.autoOption);
                    resdata.noLicnse['manualOption'] = JSON.parse(resdata.noLicnse.manualOption);
                  }
                  commit('setcertifInfo', resdata);
                  resolve();
                }
              });
            }
            resolve();
          });
          resolve();
        });

      });
    },
    getUserCertifinfo({state, commit}) {
      getCertifinfo(state.userInfo.userId).then(res => {
        if (res.code === 0) {
          let resdata = res.data;
          if (resdata.licnse) {
            resdata.licnse.autoOption = JSON.parse(resdata.licnse.autoOption);
            resdata.licnse.manualOption = JSON.parse(resdata.licnse.manualOption);
          } else {
            resdata.noLicnse['autoOption'] = JSON.parse(resdata.noLicnse.autoOption);
            resdata.noLicnse['manualOption'] = JSON.parse(resdata.noLicnse.manualOption);
          }
          commit('setcertifInfo', resdata);
        }
      });
    },
    loginOut({state, commit}) {
      commit('setUserInfo', '');
      commit('setcertifInfo', '');
      localStorage.removeItem('userInfo');
      if (window.location.href.indexOf('home') === -1) {
        router.push({path: '/home'});
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js